@if (vm$ | async; as vm) {
  @if (vm.cards; as cards) {
    <div class="start-grid" aria-label="Inicio de la unidad">
      <section class="start-card birthdays">
        <header><mat-icon>cake</mat-icon><h2>Cumpleaños</h2></header>
        <div class="card-body" aria-live="polite">
          @if (cards.members.loading) { <p class="empty">Cargando cumpleaños…</p> }
          @else if (cards.members.error) { <p class="empty">No se pudieron cargar los cumpleaños.</p> }
          @else {
            @for (birthday of cards.members.data?.birthdays; track birthday.member.id) {
              <div class="birthday">
                <span class="day-badge">{{ birthday.isToday ? 'HOY' : (birthday.date | date:'dd/MM') }}</span>
                <a [routerLink]="['/units', vm.unitId, 'members', birthday.member.id]">{{ memberName(birthday.member) }}</a>
                <small>{{ birthday.member.communityName }}</small>
              </div>
            } @empty { <p class="empty">Sin cumpleaños en los próximos 7 días</p> }
          }
        </div>
        <a class="card-footer" [routerLink]="['/units', vm.unitId, 'birthdays']">Ver todo <mat-icon>chevron_right</mat-icon></a>
      </section>

      <section class="start-card agenda">
        <header><mat-icon>calendar_month</mat-icon><h2>Agenda</h2></header>
        <div class="card-body" aria-live="polite">
          @if (cards.agenda.loading) { <p class="empty">Cargando agenda…</p> }
          @else if (cards.agenda.error) { <p class="empty">No se pudo cargar la agenda.</p> }
          @else {
            @for (service of cards.agenda.data; track service.id) {
              <a class="data-row" [routerLink]="['/units', service.organizationUnitId || vm.unitId, 'divine-services', service.id]"><span>{{ service.divineServiceTypeName || 'Servicio divino' }}<small>{{ service.startAt | date:'dd/MM HH:mm' }}</small></span></a>
            } @empty { <p class="empty">Sin servicios divinos hoy ni mañana</p> }
          }
        </div>
        <a class="card-footer" [routerLink]="['/units', vm.unitId, 'agenda']">Ver todo <mat-icon>chevron_right</mat-icon></a>
      </section>

      <section class="start-card attendance">
        <header><mat-icon>event_available</mat-icon><h2>Concurrencia</h2></header>
        <div class="card-body" aria-live="polite">
          @if (cards.services.loading) { <p class="empty">Cargando concurrencia…</p> }
          @else if (cards.services.error) { <p class="empty">No se pudo cargar la concurrencia.</p> }
          @else {
            @for (service of cards.services.data; track service.id) {
              <a class="data-row" [routerLink]="['/units', vm.unitId, 'divine-services', service.id]">
                <span>{{ service.date | date:'EEE dd/MM':'':'es-AR' }}<small>MAY {{ service.adults }} · MEN {{ service.minors }}</small></span>
                <span class="total"><small>TOT</small>{{ service.total }}</span>
              </a>
            } @empty { <p class="empty">Sin servicios divinos hasta hoy</p> }
          }
        </div>
        <a class="card-footer" [routerLink]="['/units', vm.unitId, 'latest-divine-service']">Ver último SD <mat-icon>chevron_right</mat-icon></a>
      </section>

      <section class="start-card visits development-card">
        <span class="development-ribbon">En desarrollo</span>
        <header><mat-icon>forum</mat-icon><h2>VAE</h2></header>
        <div class="card-body" aria-live="polite">
          @if (cards.visits.loading) { <p class="empty">Cargando visitas…</p> }
          @else if (cards.visits.error) { <p class="empty">No se pudieron cargar las visitas.</p> }
          @else if (cards.visits.data; as visits) {
            <p class="visit-count">
              <strong>{{ visits.visitedMemberCount }}</strong>
              <span>{{ visits.visitedMemberCount === 1 ? 'miembro visitado' : 'miembros visitados' }} <span class="visit-period">este mes</span></span>
            </p>
          } @else { <p class="empty">Sin acceso a las visitas de atención espiritual</p> }
        </div>
        @if (cards.visits.data) {
          <a class="card-footer" [routerLink]="['/units', vm.unitId, 'spiritual-assistance-visits']">Ver visitas <mat-icon>chevron_right</mat-icon></a>
        }
      </section>

      <section class="start-card members">
        <header><mat-icon>group</mat-icon><h2>Miembros</h2></header>
        <div class="card-body" aria-live="polite">
          @if (cards.members.loading) { <p class="empty">Cargando miembros…</p> }
          @else if (cards.members.error) { <p class="empty">No se pudieron cargar los miembros.</p> }
          @else {
            @for (group of cards.members.data?.groups; track group.label) {
              <div class="data-row member-count"><span>{{ group.label }}</span><span>{{ group.count }}</span></div>
            }
          }
        </div>
        <a class="card-footer" [routerLink]="['/units', vm.unitId, 'members']">Ver todo <mat-icon>chevron_right</mat-icon></a>
      </section>

      <section class="start-card communion development-card">
        <span class="development-ribbon">En desarrollo</span>
        <header><mat-icon svgIcon="chalice"></mat-icon><h2>Atendidos en el hogar</h2></header>
        <div class="card-body" aria-live="polite">
          @if (cards.communion.loading) { <p class="empty">Cargando seguimiento…</p> }
          @else if (cards.communion.error) { <p class="empty">No se pudo cargar el seguimiento.</p> }
          @else if (cards.communion.data; as communion) {
            <p class="pending"><strong>{{ communion.pending }}</strong> pendientes</p>
            <p class="communion-total">de {{ communion.total }} atendidos en el hogar</p>
            <small class="criterion">Última Santa Cena hace más de 14 días</small>
          } @else { <p class="empty">Sin acceso al seguimiento de Santa Cena</p> }
        </div>
        @if (cards.communion.data) {
          <a class="card-footer" [routerLink]="['/units', vm.unitId, 'member-follow-up']" [queryParams]="{ focus: 'communion' }">Ver todo <mat-icon>chevron_right</mat-icon></a>
        }
      </section>
    </div>
  } @else {
    <p class="access-message">No tenés acceso a la información de inicio de esta unidad.</p>
  }
} @else { <p class="access-message">Cargando inicio…</p> }
